import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';


const ReviewSearchBatchAction = (props) => {
    const { formObject, selectedDids, reloadSearch } = props;

    const onActionSuccess = () => {
        if(reloadSearch)reloadSearch(1);
    }

    return (
        <div className="uiFlexBox">
            <span><SarasTrans value="Review" />: </span>
            <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                confirm="Are you sure you want to Approve the selected documents ?"
                starIcon="applyChanges"
                starIconClassName="uiColorApproveAction"
                action={{ actionId: "save",  paramName: "batchAction", 
                actionParam: {ops:1, wrkflwactionid:2, dIds:selectedDids.join(","), sdtId:"%dataList.valLDT"}, onSuccess:onActionSuccess}}
                text={<SarasTrans value="Approve" />}></FormButton>

            <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                confirm="Are you sure you want to Reject the selected documents ?"
                starIcon="cancelChanges"
                starIconClassName="uiColorRejectAction"
                action={{ actionId: "save",  paramName: "batchAction", 
                actionParam: {ops:1, wrkflwactionid:3, dIds:selectedDids.join(","), sdtId:"%dataList.valLDT"}, onSuccess:onActionSuccess }}
                text={<SarasTrans value="Reject" />}></FormButton>
        </div>
    )
}

export default withView(ReviewSearchBatchAction, "WrkFlwApv","");